import _ from 'lodash';
import coreLogger from '@adc/logger';
import { DEFAULT_NOTIFICATION_OPTIONS, DISMISSIBLE_DURATION_THRESHOLD, DEFAULT_ERROR_TITLE, NOTIFICATION_ROLES, } from './constants';
const logger = coreLogger.forModule('AUCTIONCOM');
function prepareErrorOptions(error, overrides) {
    const message = error.message ||
        error.statusText ||
        (error.body && (error.body.title || error.body.message)) ||
        error.toString();
    return {
        ...DEFAULT_NOTIFICATION_OPTIONS,
        title: DEFAULT_ERROR_TITLE,
        message: `Error: ${message}`,
        role: NOTIFICATION_ROLES.ERROR,
        ...overrides,
    };
}
class BaseNotifier {
    constructor(notificationSystem) {
        this._notificationSystem = null;
        this._initialized = false;
    }
    initialize(notificationSystem) {
        this._notificationSystem = notificationSystem;
        this._initialized = true;
    }
    get notificationSystem() {
        return this._notificationSystem;
    }
    get initialized() {
        return this._initialized;
    }
    prepareErrorOptions(error, overrides) {
        return prepareErrorOptions(error, overrides);
    }
    prepareOptions(initialOptions) {
        let options = initialOptions;
        if (initialOptions.error) {
            options = this.prepareErrorOptions(initialOptions.error, _.omit(initialOptions, 'error'));
        }
        options = {
            ...DEFAULT_NOTIFICATION_OPTIONS,
            ..._.omitBy(options, val => _.isNil(val) || val === ''),
        };
        if (!options.autoDismiss ||
            options.dismissible > DISMISSIBLE_DURATION_THRESHOLD) {
            options.dismissible = true;
        }
        return options;
    }
    open(options) {
        if (!this._notificationSystem?.current?.open) {
            setImmediate(() => {
                this._notificationSystem?.current?.open(options) ||
                    logger.warn('Notification system not initialized, cannot open notification');
            });
        }
        else {
            this._notificationSystem?.current?.open(options);
        }
    }
    close() {
        this._notificationSystem?.current?.close();
    }
    destroy() {
    }
}
export { BaseNotifier };
//# sourceMappingURL=baseNotifier.js.map